<template>
  <j-box>
    <label class="fs3 c6 fw6 mb1">{{ $t("clients") }}</label>
    <core-select-client
      :value="value"
      :clientType="clientType"
      :allowMultiselect="true"
      @clientTypeChange="handleClientTypeChange"
      @input="$emit('input', $event)"
    />
  </j-box>
</template>

<script>
import JBox from "@/components/JBox/"
import JBaseLabel from "@/components/JBaseLabel/"
import CoreSelectClient from "@/modules/core/components/CoreSelectClient/"

export default {
	components: { JBox, CoreSelectClient },
	props: ["value"],

	data() {
		return {
			clientType: "individual" // or company
		}
	},

	methods: {
		handleClientTypeChange(value) {
			this.clientType = value
		}
	}
}
</script>
